import type * as React from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import styled from 'styled-components';

import { EmptyStateLayout } from '@xing-com/crate-components-empty-state';
import { useNotFoundStatusCode } from '@xing-com/crate-xinglet';
import { SingleSizeIllustrationErrorBigErrorPage404 } from '@xing-com/illustrations';
import { Link } from '@xing-com/link';

type NotFoundProps = {
  className?: string;
};

const Illustration = styled(SingleSizeIllustrationErrorBigErrorPage404)`
  width: 100%;
`;

const backAction = 'https://www.xing.com/';

export const NotFound: React.FunctionComponent<NotFoundProps> = ({
  className,
}) => {
  const { formatMessage } = useIntl();

  useNotFoundStatusCode();

  return (
    <EmptyStateLayout
      button={
        <Link to={backAction}>
          <FormattedMessage id="CONTENT_ERROR_404_BUTTON" />
        </Link>
      }
      className={className}
      headline={formatMessage({ id: 'CONTENT_ERROR_404_HEADLINE' })}
      image={<Illustration />}
      subline={formatMessage({ id: 'CONTENT_ERROR_404_SUBLINE' })}
    />
  );
};
